import request from '@/plugin/axios'

// 供应商价格审核接口封装
// 接口前缀 /supplierPriceReview，全部 POST；成功 code=0，业务失败 code=1 取 msg。
// 审核状态统一为字符串："0"已审核、"1"未审核、"2"驳回。

/**
 * 查询列表（分页 + 查询条件表单）
 * 注意：后端当前返回全量数组、尚未实现分页和筛选；
 * 前端仍按 分页+查询表单 传参，返回为数组时由页面本地分页，待后端支持后无缝切换。
 */
export function fetchList (query) {
  return request({
    url: '/tms/supplierPriceReview/selectSupplierPriceReview',
    method: 'post',
    data: query
  })
}

/**
 * 查询详情（表单参数 id；编辑回显备用，列表行数据完整时可直接用行数据）
 */
export function getObj (id) {
  return request({
    url: '/tms/supplierPriceReview/getSupplierPriceReviewById',
    method: 'post',
    params: { id: id }
  })
}

/**
 * 新增（JSON 业务字段，不传 id）
 * 后端根据 customerName 精确匹配已通过的供应商资质并回填 qualificationId/mdmCode；
 * 五项审核状态初始化为 "1"（未审核）。
 */
export function addObj (obj) {
  return request({
    url: '/tms/supplierPriceReview/insertSupplierPriceReview',
    method: 'post',
    data: obj
  })
}

/**
 * 编辑（JSON 业务字段 + id）
 * 后端规则：五项都已审核("0")禁止修改；任意一项驳回("2")时修改后五项全部重置为"1"并清空驳回原因；
 * 其他情况保留原审核状态。不要通过本接口修改审核状态。
 */
export function putObj (obj) {
  return request({
    url: '/tms/supplierPriceReview/updateSupplierPriceReview',
    method: 'post',
    data: obj
  })
}

/**
 * 新增暂存（JSON：业务字段，可传 {}；除供应商名称外不做业务校验）
 * 返回 data.id 为暂存 ID
 */
export function addDraft (obj) {
  return request({
    url: '/tms/supplierPriceReview/draft/save',
    method: 'post',
    data: obj
  })
}

/**
 * 编辑暂存（路径：暂存 ID；JSON：完整表单快照，覆盖保存）
 */
export function putDraft (id, obj) {
  return request({
    url: '/tms/supplierPriceReview/draft/update/' + id,
    method: 'post',
    data: obj
  })
}

/**
 * 暂存详情（路径：暂存 ID；业务字段在 data.form 中）
 */
export function getDraft (id) {
  return request({
    url: '/tms/supplierPriceReview/draft/' + id,
    method: 'get'
  })
}

/**
 * 暂存批量物理删除（ids：英文逗号分隔的暂存 ID）
 */
export function delDrafts (obj) {
  return request({
    url: '/tms/supplierPriceReview/draft/batchVoidingById',
    method: 'post',
    params: obj
  })
}

/**
 * 批量删除（ids：字符串，英文逗号分隔，如 1,2,3）
 */
export function delObjs (obj) {
  return request({
    url: '/tms/supplierPriceReview/deleteSupplierPriceReview',
    method: 'post',
    params: obj
  })
}

/**
 * 审核 / 驳回（五个审核节点平级，无先后顺序）
 * @param {String|Number} id 记录id
 * @param {String} reviewType "0"区域；"1"资源部；"2"运营总监；"3"成本；"4"总经理
 * @param {String} status "0"已审核；"1"未审核；"2"驳回
 * @param {String} reason status="2" 时必填，其他状态可不传
 */
export function reviewObj (id, reviewType, status, reason) {
  return request({
    url: '/tms/supplierPriceReview/supplierPriceReview',
    method: 'post',
    params: { id: id, reviewType: reviewType, status: status, reason: reason }
  })
}

/**
 * 撤回审批：五项全部重置为 "1"（未审核）并清空全部驳回原因；五项都已审核时不允许撤回
 */
export function withdrawObj (id) {
  return request({
    url: '/tms/supplierPriceReview/withdrawSupplierPriceReview',
    method: 'post',
    params: { id: id }
  })
}

/**
 * 价格表上传保存
 * 由 d2-uploadAli 公用组件调用
 * itemType 为价格表分类：GYSJGSY上游价格表、GYSJGCB项目组测算成本、GYSJGXY下游价格表
 */

export function uploadPriceTable (obj) {
  return request({
    url: '/tms/ossobject/supplierPriceTable',
    method: 'post',
    data: obj
  })
}
